import React from "react";
import { FireSimple } from "@phosphor-icons/react";

// "Burning today" strip — DNR-permitted ignitions planned for today so
// visible smoke self-explains. Renders nothing on days with no burns.
export default function BurningTodayStrip({ dnrBurns = [], onFlyTo }) {
  const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD local
  const burning = dnrBurns.filter(
    (b) =>
      b.status === "Approved" &&
      b.planned_date &&
      (b.planned_date === today || (b.multi_day && b.planned_date <= today))
  );
  if (burning.length === 0) return null;

  return (
    <div
      data-testid="burning-today-strip"
      className="px-4 py-2 border-b border-purple-500/30 bg-purple-500/[0.08]"
    >
      <div className="flex items-center gap-1.5 mb-1">
        <FireSimple size={11} weight="fill" className="text-purple-400" />
        <span className="text-[10px] uppercase tracking-[0.15em] font-bold text-purple-300">
          Burning today · {burning.length} planned DNR burn{burning.length > 1 ? "s" : ""}
        </span>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {burning.map((b) => (
          <button
            key={`bt-${b.id}`}
            type="button"
            data-testid={`burning-today-chip-${b.id}`}
            onClick={() => b.latitude != null && onFlyTo?.(b.latitude, b.longitude)}
            className="px-2 py-0.5 text-[15px] font-mono-tac tabular rounded-sm border border-purple-500/40 bg-purple-500/10 text-purple-200 hover:border-purple-400 transition-colors"
          >
            {b.burn_type || "Burn"}
            {b.acres != null ? ` ${Math.round(b.acres).toLocaleString()} ac` : ""}
            {b.county ? ` · ${b.county.charAt(0).toUpperCase() + b.county.slice(1)} Co.` : ""}
          </button>
        ))}
      </div>
      <div className="mt-1 text-[10px] text-purple-300/70">
        Planned, permitted burns — smoke from these areas is expected, not an emergency.
      </div>
    </div>
  );
}
